import type {
	Components,
} from '@mui/material'

export const materialUIAvatarTheme: {
	components: Components
} = {
	components: {
		MuiAvatarGroup: {
			styleOverrides: {
				avatar: {
					border: '2px solid var(--secondary-color)',
				},
			},
		},
		MuiAvatar: {
			styleOverrides: {
				root: {
					backgroundColor: 'var(--surface-container-color)',
					fontSize:        'var(--font-size-xs)',
					fontWeight:      'var(--font-weight-bold)',
				},
			},
		},
	},
}
